import { Event } from '../../../types';

export function aggregateTrackingContext({
    id,
    eventSearch,
    searchId,
    events = [],
    userId,
    currentPage,
    locale,
    sessionId,
    guestId,
}: {
    id: string;
    eventSearch: any;
    searchId: string;
    events: Event[] | undefined;
    userId: string;
    currentPage: number;
    locale?: string;
    sessionId: string;
    guestId: string;
}) {
    const SEARCH_PLACEMENT_NAME = 'search';

    const event: Event | undefined = events.find(
        (event: Event) => event.id === id,
    );
    return {
        user: {
            id: userId,
            locale,
            guestId,
            sessionId,
        },
        adId: event?.promotedListingMetadata?.adId,
        place: {
            name: SEARCH_PLACEMENT_NAME,
            position: events.findIndex((event: Event) => event?.id === id) + 1,
            page: currentPage,
            context: {
                date_filter: eventSearch.dates || null,
                query_terms: eventSearch.q || null,
                search_id: searchId,
                ...getLocationInfo(eventSearch),
            },
            placementId: event?.promotedListingMetadata?.placementId,
        },
    };
}

function getLocationInfo(eventSearch: any) {
    const placeId = Array.isArray(eventSearch.places)
        ? eventSearch.places[0]
        : null;

    if (eventSearch.onlineEventsOnly) {
        return {
            is_online: true,
        };
    }

    if (eventSearch.bbox) {
        return {
            is_online: false,
            ...getBboxCenterCoordinates(eventSearch.bbox),
        };
    }

    return {
        is_online: false,
        place_id: placeId,
    };
}

function getBboxCenterCoordinates(bbox: string) {
    try {
        const [swLng, swLat, neLng, neLat] = bbox.split(',').map(Number);
        const latitude = `${(neLat + swLat) / 2}`;
        const longitude = `${(neLng + swLng) / 2}`;
        return {
            latitude,
            longitude,
        };
    } catch (e) {
        return { latitude: null, longitude: null };
    }
}
